import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { FlotiqApi } from "@jti/rest-api";
import { StoreDetailsV1 } from "../../components/StoreDetails/components/StoreDetailsV1/StoreDetailsV1";
import { StoreDetailsV2 } from "../../components/StoreDetails/components/StoreDetailsV2/StoreDetailsV2";
import { StoreLocatorLayoutSwitcher } from "../../components/StoreLocator/components/StoreLocatorLayoutSwitcher";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import { VerticalLoader } from "../VerticalLoader";
import styles from "./StoreDetails.module.scss";
const getStoreDetailsDataFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const entries = Array.from(params.entries());
    const booleanParamKeys = new Set([
        "isOpeningHoursEnabled",
        "isOpeningHoursBreaksEnabled",
        "isAvailableDevicesEnabled",
        "isAvailableSticksEnabled",
        "isStoreTypeEnabled",
        "isAvailableServicesEnabled",
        "isGeneralAnnouncementEnabled",
        "isVendingMachineEnabled",
    ]);
    return Object.fromEntries(entries.map(([key, value]) => {
        if (booleanParamKeys.has(key)) {
            return [key, value === "true"];
        }
        return [key, value];
    }));
};
export const StoreDetails = ({ storeIcons, storeLocatorUrl }) => {
    const { __ } = useTranslations();
    const { locationServiceMapProvider } = useConfig();
    const [storeDetails, setStoreDetails] = useState();
    const isHeaderAddressVisible = locationServiceMapProvider !== "naver";
    const updateStoreLocatorData = useCallback(async () => {
        const storeDetailsDataFromUrl = getStoreDetailsDataFromUrl();
        const flotiqApi = FlotiqApi.init();
        const store = await flotiqApi.getStoreById(storeDetailsDataFromUrl.shopId);
        const { Street, City, ZipCode } = store;
        const address = [Street, City, ZipCode].filter(Boolean).join(", ");
        setStoreDetails({
            store: { ...store, address },
            isOpeningHoursEnabled: storeDetailsDataFromUrl.isOpeningHoursEnabled,
            isOpeningHoursBreaksEnabled: storeDetailsDataFromUrl.isOpeningHoursBreaksEnabled,
            isAvailableDevicesEnabled: storeDetailsDataFromUrl.isAvailableDevicesEnabled,
            isAvailableSticksEnabled: storeDetailsDataFromUrl.isAvailableSticksEnabled,
            isGeneralAnnouncementEnabled: storeDetailsDataFromUrl.isGeneralAnnouncementEnabled,
            isAvailableServicesEnabled: storeDetailsDataFromUrl.isAvailableServicesEnabled,
            isStoreTypeEnabled: storeDetailsDataFromUrl.isStoreTypeEnabled,
            isVendingMachineEnabled: storeDetailsDataFromUrl.isVendingMachineEnabled,
        });
    }, [setStoreDetails]);
    useEffect(() => {
        let ignore = false;
        if (!ignore) {
            updateStoreLocatorData();
        }
        return () => {
            ignore = true;
        };
    }, [updateStoreLocatorData]);
    if (!storeDetails) {
        return _jsx(VerticalLoader, { className: styles.loaderContainer, dataTestId: "storeDetailsLoader" });
    }
    return (_jsxs("div", { className: styles.storeDetailsContainer, children: [_jsx(StoreLocatorLayoutSwitcher, { layout: "v1", children: _jsx(StoreDetailsV1, { storeDetails: storeDetails, isHeaderAddressVisible: isHeaderAddressVisible, storeIcons: storeIcons }) }), _jsx(StoreLocatorLayoutSwitcher, { layout: "v2", children: _jsx(StoreDetailsV2, { storeDetails: storeDetails, storeIcons: storeIcons, storeLocatorUrl: storeLocatorUrl }) })] }));
};
//# sourceMappingURL=StoreDetails.js.map